import {createContext} from "react";
import {Speaker} from "../../../model/SpeakerInvitationCreateMessage";

export interface SpeakersContextState {
    speakers: Speaker[];
    onSpeakerChange: ((speaker: Speaker) => void) | undefined;
    onAddSpeaker: (() => void) | undefined;
    onSpeakerRemove: ((uiId: number) => void) | undefined;
}

export const SpeakersContext = createContext<SpeakersContextState>({
    speakers:[],
    onSpeakerChange: undefined,
    onAddSpeaker: undefined,
    onSpeakerRemove: undefined,
});
